<app-base-modal
  [title]="dialogData.title"
>
  @if (isLoading) {
    <app-loader/>
  }
  <div class="content">
    @for (accordion of dialogData.filesData; track $index) {
      <mat-accordion>
        <mat-expansion-panel (toggle)="accordionToggle(accordion.key)">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ getAccordionTitle(accordion) }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="accordion-content">
            @for (key of dialogData.keysType; track $index) {
              @if (key === accordion.key) {
                @for (item of multiFilesParamsService.multiFileParams()?.[key]; track $index) {
                  <app-file-card
                    [fileCard]="{
                      id: item.id,
                      fileParams: item.file,
                      fileType: key,
                      isEditModeActive: getEditMode(),
                      shouldCheckImageType: false
                    }"
                    (handleDelete)="handleDelete($event, item)"
                  />
                }
              }
            }
            @if (dialogData.isGenerate) {
              <div class="buttons-container">
                <button
                  mat-button
                  color="primary"
                  (click)="handleGenerate(accordion.key)"
                >
                  Сгенирировать
                </button>
              </div>
            } @else {
              @if (loginAndRoles?.role !== 'ROLE_PROMOTION_SPECIALIST') {
                <app-file-upload-card
                  [fileUploadParams]="{
                    recordId: dialogData.recordId,
                    parentId: dialogData.recordCalendarId,
                    type: accordion.key,
                    entityFileType: 'RECORD_CALENDAR'
                  }"
                  [isEditModeActive]="isEditModeActive"
                  (attachFile)="attachFile($event)"
                />
              }
            }
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    }
  </div>
</app-base-modal>
